import { FeatureName, FeatureValues } from './types'
import { isSupportedFeature } from './featuresSchemaService'
import _ from 'lodash'
import { parseStringifiedFeatureValue } from './featuresService.window'

export function getUrlFeatures(query: Record<string, string | boolean>): Window | {} {
  return Object.entries(query).reduce((output: FeatureValues, parameter) => {
    const [name, value] = parameter

    return getOutput(name, String(value), output)
  }, {})
}

function getOutput(name: string, value: string, output: FeatureValues): FeatureValues {
  const attribute = _.snakeCase(name).toUpperCase() as FeatureName

  if (!isSupportedFeature(attribute)) {
    return output
  }

  const queryValue = parseStringifiedFeatureValue(attribute, value)

  if (queryValue === null) {
    return output
  }

  return { ...output, [attribute]: queryValue }
}
